module.exports = __webpack_public_path__ + "static/media/undraw_add_user_ipe3.c64d5dbc.svg";